module.exports = __webpack_public_path__ + "img/30_34.fe1a3e5a.png";